/**
 * Phase 14c — operator preferences (dashboard config).
 *
 * Migrated from `admin/dashboard.schema.ts` at Phase 14c lockstep with
 * Convention 01's PERSONA_ALLOWLIST extension; URL surface moved from
 * `/admin/me/preferences` to `/me/operator/preferences`.
 *
 * Schema names renamed AdminPreference* → OperatorPreference* for
 * consistency with the new `operator/` persona namespace. Table column
 * shapes unchanged.
 */
import { z } from 'zod';
export const OperatorPreferenceResponseSchema = z.object({
    userId: z.string().uuid(),
    dashboardMetricIds: z.array(z.string().min(1)),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const OperatorPreferencePatchRequestSchema = z.object({
    /** Ordered list of metric ids; order is preserved + drives card layout. */
    dashboardMetricIds: z.array(z.string().min(1)).max(20),
});
//# sourceMappingURL=preferences.schema.js.map